import React from 'react';
import { observer } from 'mobx-react';
import { Input } from 'cd-eft/components/common/Input/Input';
import { ComboBox, IOption } from 'cd-eft/components/common/ComboBox';
import { CustomInput } from 'reactstrap';

interface IConfig {
  label?: string;
  inputType: string;
  options?: IOption[];
  name: string;
  placeholder?: string;
  readOnly?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  decimalPlaces?: number;
}

interface IInputsElement {
  config: IConfig;
  value: any;
  onChange: (event: {}) => void;
  onBlur?: (event: { target: any }) => void;
  red?: boolean;
}

const InputsElementComponent = ({
  config, 
  value, 
  onChange, 
  onBlur, 
  red
}: IInputsElement) => {
  const {
    label,
    inputType,
    options,
    name,
    placeholder,
    readOnly = false,
    disabled = false,
    hidden = false,
    decimalPlaces = 2
  } = config;
  const step = Math.pow(10, -decimalPlaces);

  return (
    <>
      {(!hidden) && (inputType === 'text' || inputType === 'number') && (
        <Input
          className={red ? 'usa-input--error' : ''}
          placeholder={placeholder}
          idAndName={name}
          valid={true}
          value={value}
          type={inputType}
          onChange={onChange || (() => {})}
          onBlur={onBlur || (() => {})}
          label={label || ''}
          wrapperClassName={`${name}-input`}
          readOnly={readOnly}
          disabled={disabled}
          step={step}
        />
      )}
      {inputType === 'dropdown' && (
        <ComboBox
          className={red ? 'usa-input--error' : ''}
          wrapperName={`${name}-input`}
          label={label}
          idAndName={name}
          valid={true}
          value={value}
          onChange={onChange || (() => {})}
          onBlur={onBlur || (() => {})}
          options={options || []}
          errorMsg=''
          disabled={disabled}
        />
      )}
      {inputType === 'title' && (
        <h3 className={`${name} subheader`}>{label}</h3>
      )}
      {inputType === 'checkbox' && (
        <div className={`${name}-checkbox`}>
          <input
            className="usa-checkbox__input"
            data-behavior="select-table-row"
            id={name}
            type={inputType}
            name={name}
            value={name}
            checked={value}
            disabled={disabled}
            onChange={onChange || (() => {})}
          />
          <label className="usa-checkbox__label align-items-center" htmlFor={name}>{label}</label>
        </div>
      )}
      {inputType === 'switch' && (<div className="d-flex flex-row align-items-center">
        <label
          className={`m-0 pr-2 ${value ? 'select-label' : 'select-label-unchecked'}`}
          htmlFor={name}
        >
          {label}
        </label>
        <CustomInput
          id={name}
          name={name}
          type="switch"
          className={`pb-2 ${value ? ' selected' : ''}`}
          checked={value}
          onChange={onChange}
        /></div>
      )}
    </>
  );
};

export const InputsElement = observer(InputsElementComponent);